/**
 * LabelConnect Constants
 * Shared configuration for Label Connect components
 */

export const API = process.env.REACT_APP_BACKEND_URL || '';

// Sub-tab configuration
export const SUB_TABS = [
  { id: 'labelradar', name: 'Record Labels', description: 'powered by LabelRadar' },
  { id: 'local', name: 'Local Labels', description: 'Labels near you via Google Places' },
  { id: 'private', name: 'Private Labels', description: 'User-submitted labels' },
  { id: 'integration', name: 'LabelRadar Integration', description: 'Coming soon' }
];

// Genre filter options
export const GENRE_OPTIONS = [
  { value: 'all', label: 'All Genres' },
  { value: 'techno', label: 'Techno' },
  { value: 'house', label: 'House' },
  { value: 'tech house', label: 'Tech House' },
  { value: 'deep house', label: 'Deep House' },
  { value: 'drum & bass', label: 'Drum & Bass' },
  { value: 'dubstep', label: 'Dubstep' },
  { value: 'trance', label: 'Trance' },
  { value: 'progressive house', label: 'Progressive House' },
  { value: 'electro', label: 'Electro' },
  { value: 'melodic', label: 'Melodic' },
  { value: 'bass', label: 'Bass Music' },
  { value: 'afro house', label: 'Afro House' },
  { value: 'psy-trance', label: 'Psy-Trance' }
];

// Sort options
export const SORT_OPTIONS = [
  { value: 'fans', label: 'Most Fans' },
  { value: 'name-asc', label: 'A-Z' },
  { value: 'name-desc', label: 'Z-A' },
  { value: 'country', label: 'By Country' }
];

// Dropdown select style
export const selectStyle = {
  padding: '0.5rem 2rem 0.5rem 0.75rem',
  borderRadius: '8px',
  border: '1px solid rgba(251, 191, 36, 0.3)',
  background: 'rgba(30, 20, 50, 0.8)',
  color: '#fff',
  fontSize: '0.8rem',
  outline: 'none',
  cursor: 'pointer',
  appearance: 'none',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  minWidth: '120px'
};

// Common input style
export const inputStyle = {
  width: '100%',
  padding: '0.6rem',
  borderRadius: '8px',
  border: '1px solid rgba(251, 191, 36, 0.3)',
  background: 'rgba(30, 20, 50, 0.8)',
  color: '#fff',
  fontSize: '0.85rem',
  outline: 'none',
  boxSizing: 'border-box'
};

// Common label style
export const labelStyle = {
  display: 'block',
  color: '#fbbf24',
  fontSize: '0.85rem',
  marginBottom: '0.4rem'
};
